import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import DualPathHero from "./sections/DualPathHero";
import WeeklyGigRentalsPreview from "./sections/WeeklyGigRentalsPreview";
import TrainingAcademyTeaser from "./sections/TrainingAcademyTeaser";
import DriverTrustSignals from "./sections/DriverTrustSignals";
import FleetCategories from "./sections/FleetCategories";
import FooterHub from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <DualPathHero />
      <WeeklyGigRentalsPreview />
      <TrainingAcademyTeaser />
      <DriverTrustSignals />
      <FleetCategories />
      <FooterHub />
    </div>;
}